export const TOP_QUEUES = "TOP_QUEUES";
export const LONGEST_TIME_INFO = "LONGEST_TIME_INFO";
export const CALL_CUSTOMER_STATUS_AGGREGATE = "CALL_CUSTOMER_STATUS_AGGREGATE";

export const topQueueCallDetails = (payload) => ({
  type: TOP_QUEUES,
  payload,
});

export const setLongestTimeDetails = (payload) => ({
  type: LONGEST_TIME_INFO,
  payload,
});

export const aggregateCallMonitoringCustomerStatus = (payload) => ({
  type: CALL_CUSTOMER_STATUS_AGGREGATE,
  payload,
});